import React, { useEffect, useMemo, useState } from 'react';
import { GetAllSponsors, GenerateQRCode } from '../../Backend/ApiCalls';
import { useNavigate } from 'react-router-dom';
import './SponsorsListComponent.css';
import { BottomNav } from '../BottomNav';
import { resolveSponsorImage, sponsorHasPromotion } from '../../utils/sponsorMedia';

export const getPromotionState = (sponsor, now = new Date()) => {
  if (sponsor?.active === false || sponsor?.promotionActive === false) return 'disabled';
  if (!sponsorHasPromotion(sponsor)) return 'none';
  const start = sponsor?.startDate ? new Date(`${sponsor.startDate}T00:00:00`) : null;
  const end = sponsor?.endDate ? new Date(`${sponsor.endDate}T23:59:59.999`) : null;
  if (start && !Number.isNaN(start.getTime()) && now < start) return 'upcoming';
  if (end && !Number.isNaN(end.getTime()) && now > end) return 'expired';
  return 'active';
};

const STATE_LABEL = { active: 'Activo', upcoming: 'Próximo', expired: 'Caducado', disabled: 'Desactivado' };
const formatDate = (value) => value ? new Date(`${value}T00:00:00`).toLocaleDateString('es-ES') : '';

function SponsorsListComponent(props) {
  const [sponsors, setSponsors] = useState([]);
  const [filter, setFilter] = useState('all');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { user } = props;

  useEffect(() => {
    GetAllSponsors().then(({ response, data }) => {
      if (!response.ok) throw new Error(data?.error || 'No se pudieron cargar los descuentos');
      setSponsors((data || []).filter((sponsor) => sponsorHasPromotion(sponsor)));
    }).catch((err) => setError(err.message));
  }, []);

  const visibleSponsors = useMemo(() => sponsors.filter((sponsor) => {
    const state = getPromotionState(sponsor);
    return filter === 'all' || state === filter;
  }), [sponsors, filter]);

  const handleRedeem = async (sponsor) => {
    setError('');
    try {
      const { response, data } = await GenerateQRCode(sponsor.id);
      if (!response.ok) throw new Error(data?.error || 'No se pudo generar el QR');
      navigate('/validate-qr', { state: { ...data, sponsor: data.sponsor || sponsor } });
    } catch (err) { setError(err.message); }
  };

  return (
    <div className="perfil-component discounts-page">
      <BottomNav I18n={props.I18n} user={user} />
      <div className="discounts-heading"><h1>Descuentos</h1></div>
      <div className="discount-filters" aria-label="Filtrar descuentos">
        {[['all', 'Todos'], ['active', 'Activos'], ['upcoming', 'Próximos'], ['expired', 'Caducados']].map(([value, label]) => (
          <button key={value} className={filter === value ? 'active' : ''} onClick={() => setFilter(value)}>{label}</button>
        ))}
      </div>
      {error && <p className="discount-error" role="alert">{error}</p>}
      <div className="sponsors-list-container">
        {visibleSponsors.map((sponsor) => {
          const state = getPromotionState(sponsor);
          return (
            <article key={sponsor.id} className="sponsor-card">
              {sponsor.promotionImage
                ? <img src={resolveSponsorImage(sponsor.promotionImage)} alt={`Promoción de ${sponsor.name}`} />
                : sponsor.logo && <img src={resolveSponsorImage(sponsor.logo)} alt={`Logo de ${sponsor.name}`} />}
              <h2>{sponsor.name}</h2><h3>{sponsor.promotion}</h3>
              {sponsor.description && <p>{sponsor.description}</p>}
              <p className={`discount-state state-${state}`}>{STATE_LABEL[state]}</p>
              {sponsor.endDate && <p>Válido hasta: <strong>{formatDate(sponsor.endDate)}</strong></p>}
              {sponsor.conditions && <p><strong>Condiciones:</strong> {sponsor.conditions}</p>}
              <button onClick={() => handleRedeem(sponsor)} disabled={state !== 'active'}>
                {state === 'active' ? 'Usar descuento' : STATE_LABEL[state]}
              </button>
            </article>
          );
        })}
      </div>
    </div>
  );
}

export default SponsorsListComponent;
